import { render, staticRenderFns } from "./BdAuthWorkWorkThird.vue?vue&type=template&id=8f117200&"
import script from "./BdAuthWorkWorkThird.vue?vue&type=script&lang=js&"
export * from "./BdAuthWorkWorkThird.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports